import { render } from "./TheAnalysisItem.vue?vue&type=template&id=5fb65d92&ts=true"
import script from "./TheAnalysisItem.vue?vue&type=script&lang=ts"
export * from "./TheAnalysisItem.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__